import { auth, db, storage } from "./index";
import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  sendPasswordResetEmail,
} from "firebase/auth";

import {
  // getFirestore,
  getDocs,
  collection,
  // addDoc,
  setDoc,
  query,
  where,
  // getDocs,
  doc,
  updateDoc,
  getDoc,
  deleteDoc,
} from "firebase/firestore";

import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

import { setDataInLocalStorage } from "../utils";
import { async } from "@firebase/util";

export const registerWithEmailAndPassword = async (
  email,
  password,
  firstName,
  lastName,
  contact,
  status
) => {
  try {
    //create user
    const res = await createUserWithEmailAndPassword(auth, email, password);
    const user = res.user;
    const uid = user.uid;

    //set data in db
    await setDoc(doc(db, "users", uid), {
      uid: uid,
      firstName,
      authProvider: "local",
      email,
      lastName,
      contact,
      role: "user",
      registeredInEvent: false,
      status,
    });

    const accessToken = user.accessToken;

    setDataInLocalStorage("userData", {
      uid: uid,
      accessToken: accessToken,
    });

    // return result
    return {
      uid,
    };
  } catch (err) {
    return { error: err.message };
  }
};

export const logInWithEmailAndPassword = async (email, password) => {
  try {
    const user = await signInWithEmailAndPassword(auth, email, password);

    const uid = user.user.uid;
    const accessToken = user.user.accessToken;

    setDataInLocalStorage("userData", {
      uid: uid,
      accessToken: accessToken,
    });

    return {
      ...user,
    };
  } catch (err) {
    console.error(err);
    return { error: err.message };
  }
};

export const getUserData = async (userId) => {
  try {
    const q = query(collection(db, "users"), where("uid", "==", userId));
    let data = "";
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      // doc.data() is never undefined for query doc snapshots
      data = doc.data();
    });
    return data;
  } catch (error) {
    return error;
  }
};

export const logout = async () => {
  await signOut(auth);
  localStorage.removeItem("userData");
  return true;
};

export const updateUser = async (userData, userId, isTeams) => {
  const {
    cnic,
    committeePreference,
    committeePreference2,
    gender,
    reference,
    accommodation,
    registeredInEvent,
    instituteName,
    instituteAddress,
    image,
    status,
  } = userData;


  let imageUrl = "";

  if (typeof image === "object") {
    const storageRef = ref(storage, `users/${image.name}`);

    // 'file' comes from the Blob or File API
    return uploadBytes(storageRef, image).then((snapshot) => {
      return getDownloadURL(ref(storage, `users/${image.name}`)).then(
        async (url) => {
          imageUrl = url;
          const userInfo = {
            cnic,
            committeePreference,
            committeePreference2,
            gender,
            reference,
            accommodation,
            registeredInEvent,
            instituteName,
            instituteAddress,
            imageUrl: imageUrl,
          };
          try {
            const docRef = doc(db, "users", userId);
            return await updateDoc(docRef, userInfo)
              .then(() => {
                return true;
              })
              .catch(() => false);
          } catch (error) {
            console.log("error", error);
            return false;
          }
        }
      );
    });
  } else {
    //type of image string -> url
    let userInfo = {};
    if (isTeams) {
      userInfo = {
        teams: userData.teams,
        registeredInEvent,
        status,
      };
    } else {
      userInfo = {
        cnic,
        committeePreference,
        committeePreference2,
        gender,
        reference,
        accommodation,
        registeredInEvent,
        instituteName,
        instituteAddress,
        imageUrl: image,
      };
    }

    try {
      const docRef = doc(db, "users", userId);
      return await updateDoc(docRef, userInfo)
        .then(() => {
          return true;
        })
        .catch(() => false);
    } catch (error) {
      return false;
    }
  }
};

export const uploadInvoice = async (image, userId) => {
  if (typeof image === "object") {
    const storageRef = ref(storage, `users/${image.name}`);

    // 'file' comes from the Blob or File API
    return uploadBytes(storageRef, image).then((snapshot) => {
      return getDownloadURL(ref(storage, `users/${image.name}`)).then((url) => {
        try {
          const userInfo = {
            depositSlipUrl: url,
            status: "pending",
          };
          const docRef = doc(db, "users", userId);
          return updateDoc(docRef, userInfo)
            .then(() => {
              return true;
            })
            .catch(() => false);
        } catch (error) {
          return false;
        }
      });
    });
  }
};

export const getPrice = async () => {
  const docRef = doc(db, "fee", "7KAdByedlOqgrM3U98uU");
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    return docSnap.data();
  } else {
    return false;
  }
};

export const uploadImage = async (image) => {
  const storageRef = ref(storage, `users/${image.name}`);

  return uploadBytes(storageRef, image).then((snapshot) => {
    return getDownloadURL(ref(storage, `users/${image.name}`))
      .then(async (url) => {
        return url;
      })
      .catch((err) => console.log(err));
  });
};

export const getAllUsers = async () => {
  let users = [];
  try {
    const querySnapshot = await getDocs(collection(db, "users"));
    querySnapshot.forEach((doc) => {
      let user = doc.data();
      users.push(user);
    });
    return users;
  } catch (error) {
    console.log(error);
  }
};

export const deleteUser = async (userId) => {
  try {
    await deleteDoc(doc(db, "users", userId));
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export const updateStatus = async (status, userId) => {
  try {
    const docRef = doc(db, "users", userId);
    return await updateDoc(docRef, { status: status }).then(() => {
      return true;
    });
  } catch (error) {
    return false;
  }
};

export const resetPassword = (email) => {
  return sendPasswordResetEmail(auth, email)
    .then((a) => {
      return true;
    })
    .catch((err) => false);
};
